import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/OffersService';

const getApiToken = () => {
    const { config } = diContainer.get(serviceNames.configRepository);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (config as any).config?.pgApiTokens?.offers || config.apiAuthToken;
};

export const getGlobalHeaders = (): Record<string, string> => {
    const auth = btoa(getApiToken());
    const AuthorizationCredentials = `Basic ${auth}`;
    const Authorization = AuthorizationCredentials;

    return {
        Authorization,
        AuthorizationCredentials
    };
};
